// frontend/src/components/company/CompanyTabs.jsx
import { Tab } from "../ui/Field";

export const CompanyTabs = ({ activeTab, onTabChange }) => (
  <div className="tabs" role="tablist" aria-label="Company sections">
    <Tab id="overview" active={activeTab === "overview"} onClick={onTabChange}>
      Overview
    </Tab>
    <Tab id="roles" active={activeTab === "roles"} onClick={onTabChange}>
      Owners & Officers
    </Tab>
    <Tab id="documents" active={activeTab === "documents"} onClick={onTabChange}>
      Documents
    </Tab>
    <Tab id="addresses" active={activeTab === "addresses"} onClick={onTabChange}>
      Addresses
    </Tab>
    <Tab id="bank" active={activeTab === "bank"} onClick={onTabChange}>
      Bank Accounts
    </Tab>
    <Tab id="notes" active={activeTab === "notes"} onClick={onTabChange}>
      Notes
    </Tab>
    <Tab id="reviews" active={activeTab === "reviews"} onClick={onTabChange}>
      Reviews
    </Tab>
    <Tab id="statusHistory" active={activeTab === "statusHistory"} onClick={onTabChange}>
      Status History
    </Tab>
  </div>
);
